import type { Client } from 'openapi-fetch';
import { emsClient } from '@ngsos/portal-core/api/clients';
import type { EmsPaths } from '@ngsos/portal-core/api/ems';

export const emsApi: Client<EmsPaths> = new Proxy({} as Client<EmsPaths>, {
  get(_target, property) {
    return Reflect.get(emsClient(), property);
  },
});
